export default {
	welcome_back: 'Bentornato',
	enter_email_password: 'Inserisci la tua email e password per accedere',
	username: 'Nome utente',
	password: 'Password',
	remember_me: 'Ricordami',
	no_account_sign_up: 'Non hai un account?',
	company: 'Azienda',
	about_us: 'Chi siamo',
	team: 'Squadra',
	products: 'Prodotti',
	blog: 'Blog',
	pricing: 'Prezzi',
	copyright: 'Copyright © 2024 EquiUp.',
	sign_in: 'Accedi',
	sign_up: 'Registrati',
	error_wrong_username: 'Nome utente o password non validi.',
	operation_saved: 'Salvataggio riuscito',
	members: 'Soci',
	member: 'Socio',
	first_name: 'Nome',
	last_name: 'Cognome',
	profession: 'Professione',
	email: 'Email',
	location: 'Posizione',
	phone_number: 'Telefono',
	photo_url: 'URL foto',
	first_last_name: 'Nome Cognome',
	card: 'Tessera',
	expires_at: 'Data scadenza',
	edit: 'Modifica',
	delete: 'Cancella',
	add: 'Aggiungi',
	irreversible_action: 'Azione irreversibile',
	do_u_confirm: 'Confermi?',
};
